import React from 'react';
import Finance from '../../../assets/How_It_Works/Finance_Blue.svg';
import Charts from '../../../assets/How_It_Works/Charts.svg';
import Cart from '../../../assets/How_It_Works/Cart_Blue.svg';
import './StockHowItWorks.css';

const StockHowItWorks = () => {
    return (
        <div className="my-4 container mx-auto row align-items-center gy-5 gx-3">
            <div className="col-md-7">
                <h3>Analyse Financials Of Assets</h3>
                <br/>
                <p className="w-75">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Deleniti iste doloribus, ipsa unde repellendus laudantium sunt quaerat nemo architecto aliquid tempora officiis magni quia aperiam veritatis inventore blanditiis, esse ab?
                </p>
            </div>
            <div className="col-md-5">
                <img src={Finance} alt="finance" className="w-100"/>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <div className="col-md-5">
                <img src={Charts} alt="chart" className="w-100"/>
            </div>
            <div className="col-md-7" id="second-row-content">
                <h3 className="">Analyse Financials Of Stock</h3>
                <br/>
                <p className="w-100">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Deleniti iste doloribus, ipsa unde repellendus laudantium sunt quaerat nemo architecto aliquid tempora officiis magni quia aperiam veritatis inventore blanditiis, esse ab?
                </p>
            </div>
            <div className="col-md-7">
                <h3>Analyse Financials Of Stock</h3>
                <br/>
                <p className="w-75">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Deleniti iste doloribus, ipsa unde repellendus laudantium sunt quaerat nemo architecto aliquid tempora officiis magni quia aperiam veritatis inventore blanditiis, esse ab?
                </p>
            </div>
            <div className="col-md-5">
                <img src={Cart} alt="finance" className="w-100"/>
            </div>
        </div>
    )
}

export default StockHowItWorks
